module.exports = __webpack_public_path__ + "media/share_images/drumkit-c55563ac.svg";